/**
 * Agenda das clínicas de saúde do Sindilegis (Especificação Benefícios §6). Os horários vêm
 * do e-Sindilegis pela main-api (/api/health/schedule).
 */
export const ESPECIALIDADES = {
  nutricao: { nome: 'Nutrição', clinica: 'Clínica de Nutrição' },
  psicologia: { nome: 'Psicologia', clinica: 'Clínica de Psicologia' },
  fisioterapia: { nome: 'Fisioterapia', clinica: 'Clínica de Fisioterapia' },
};

// Planos conveniados divulgados na página de informações do benefício.
export const CONVENIOS = [
  'AFEB BRASAL',
  'AFFEGO',
  'ANAFE SAÚDE',
  'ASETE (ASTE)',
  'CAESAN',
  'CARE PLUS',
  'CASEC (CODEVASF)',
  'CASEMBRAPA (EMBRAPA)',
  'CEAM BRASIL',
  'CNTI',
  'CONAB',
  'FAPES (BNDES)',
  'FASCAL',
  'DF SAÚDE',
  'LIFE EMPRESARIAL',
  'OMINT SAÚDE',
  'PF SAÚDE (Polícia Federal)',
  'PLAN ASSISTE (MPU)',
  'PLAS/JMU (STM)',
  'PMDF (Polícia Militar do Distrito Federal)',
  'POSTAL SAÚDE (ECT)',
  'PROASA',
  'PRÓ-SAÚDE (CÂMARA DOS DEPUTADOS)',
  'PRÓ-SAÚDE (TJDFT)',
  'PRÓ-SOCIAL (TRF)',
  'REAL GRANDEZA',
  'SAÚDE CAIXA',
  'SERPRO',
  'SIS SENADO',
  'STF-MED (STF)',
  'TRE SAÚDE',
  'TRT SAÚDE',
  'TST SAÚDE',
  'UNAFISCO (SINDIFISCO)',
];

export const STATUS = {
  Agendado: { cor: '#378587', rotulo: 'Agendado' },
  Realizado: { cor: '#2e7d32', rotulo: 'Realizado' },
  Cancelado: { cor: '#5f6368', rotulo: 'Cancelado' },
  'Não compareceu': { cor: '#8d5524', rotulo: 'Não compareceu' },
};

/** Índice "dd/mm/aaaa" → dia da disponibilidade, para o calendário habilitar só esses dias. */
export const indexarDias = (dias) =>
  (dias || []).reduce((acc, dia) => {
    if (dia && dia.data && dia.horarios && dia.horarios.length)
      acc[dia.data] = dia;
    return acc;
  }, {});

export const doisDigitos = (n) => String(n).padStart(2, '0');

/** Chave "dd/mm/aaaa" de uma data do calendário (moment ou Date). */
export const chaveDoDia = (data) => {
  if (!data) return '';
  const d = typeof data.toDate === 'function' ? data.toDate() : new Date(data);
  return `${doisDigitos(d.getDate())}/${doisDigitos(
    d.getMonth() + 1
  )}/${d.getFullYear()}`;
};

/** Converte "dd/mm/aaaa" em Date local (para posicionar o calendário no primeiro dia livre). */
export const dataDaChave = (chave) => {
  const [dia, mes, ano] = String(chave || '')
    .split('/')
    .map(Number);
  return dia && mes && ano ? new Date(ano, mes - 1, dia) : null;
};

export const daEspecialidade = (lista, especialidade) =>
  (lista || []).filter((a) => a.especialidade === especialidade);

export const bloqueioDaEspecialidade = (bloqueios, especialidade) =>
  (bloqueios || []).find((b) => b.especialidade === especialidade) || null;

export const mensagemDeErro = (erro, padrao) => {
  try {
    return erro.response.data.messages[0] || padrao;
  } catch (e) {
    return padrao;
  }
};
